import { Typography } from "@mui/material";
import { useLangContext } from "../../../context/langContext";
import { statusInfo, statusStyles } from "../../../constants/status";

export enum OriginEnum {
  BROADCASTING_NUMBER = "broadcastingNumber",
  BROADCASTING_STATUS = "broadcastingStatus",
  FILE = "file",
  TICKET = "ticket",
  TOKEN = "token",
  PAYMENT = "payment",
  SERVER = "server",
  PARTNER = "partner",
  BROADCASTING_SPEED = "broadcastingSpeed",
  STATUS_CODE = "statusCodes",
}

interface IInfoBadge {
  origin: OriginEnum;
  status:
    | "created"
    | "waiting_for_send"
    | "sending"
    | "failed"
    | "answered"
    | "blocked"
    | "no_answer"
    | "busy"
    | "rejected"
    | "unreachable"
    | "device_off"
    | "invalid_number"
    | "canceled"
    | "pending"
    | "paying"
    | "paid"
    | "SENT"
    | "verified"
    | "online"
    | "removed"
    | "closed"
    | "offline"
    | "Error"
    | "complete"
    | "in_process"
    | "active"
    | "normal"
    | "fast"
    | "inactive"
    | 200
    | 201
    | 500
    | 422
    | 401
    | 403
    | 404;
  mx?: string;
}

export default function InfoBadge({
  status,
  mx,
  origin,
}: Readonly<IInfoBadge>) {
  const { lang } = useLangContext();

  const info = statusInfo[lang];  
  return (
    <Typography
      variant="warningMediumBold"
      sx={{
        // @ts-ignore
        ...statusStyles[origin][status],
        borderRadius: "99px",
        height: "fit-content",
        px: "16px",
        py: "3px",
        mx: mx ? mx : "auto",
      }}
    >
      {/* @ts-ignore*/}
      {info[origin][status]}
    </Typography>
  );
}
